import { useActualIncidentId, useGroupGuid } from '../commonHooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { IncidentRoster } from './incidentRoster.types';
import config from '../../../../constants/apiConfig';
import { incidentRosterKeys } from './incidentRoster.queryKeys';

export const createDraftRoster = async (
  incidentId: string,
  groupId: string
) => {
  const response = await axios.post<IncidentRoster>(
    config.apiGateway.createDraftRoster(incidentId),
    { groupId }
  );
  return response.data;
};
export const useCreateDraftRoster = () => {
  const incidentId = useActualIncidentId();
  const groupId = useGroupGuid();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => createDraftRoster(incidentId, groupId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: incidentRosterKeys.draftByIncident(incidentId),
      });
    },
  });
};
